const state = {
    services: [],
    originalServices: null,
    isLoad: false
}

const mutations = {
    setState: (state, {
        key,
        value
    }) => {
        state[key] = value;
    },
    setOriginalServices: (state, data) => state.originalServices = data,
    setServices: (state, data) => {
        if (state.services.length > 0) {
            return;
        }

        data.forEach(element => {
            state.services.push({
                value: element.id,
                label: element.title,
                slug: element.slug
            })
        });
    }
}

const actions = {
    async fetch({
        commit
    }) {
        const response = await this.$api.services.fetch();

        commit('setOriginalServices', response.data.services);
        commit('setServices', response.data.services);
    }
}

const getters = {
    services: state => state.services,
    originalServices: state => state.originalServices,
    isLoad: state => state.isLoad
}

export default {
    namespaced: true,

    state,
    mutations,
    actions,
    getters
}